import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { useHistory, useLocation } from "react-router";
import { stringify } from "query-string";
import { mutateErrors } from "../../../utils";
import { useProgramConfigHigher } from "../../program/modals/higher/hooks/useProgramConfigHigher";
import { useIntakeConfigHigher } from "../../program/modals/hooks/useIntakeConfigHigher";
import { useSchoolId } from "../../school/hooks/useSchoolId";
import { useAcademicConfig } from "../modals/higher/hooks/useAcademicConfig";
import { replaceForURLOptions } from "../helpers/parseFilterToUrlOptions";
import { IAcademicListItemHigher } from "../types";
import useAcademicQueriesHigher from "./useAcademicQueriesHigher";

export const useAcademicsPageHigher = (disableAutoFetch: boolean = false) => {
  const academicWizardConfigs = useAcademicConfig();
  const programWizardConfigs = useProgramConfigHigher();
  const intakeWizardConfigs = useIntakeConfigHigher();
  const history = useHistory();
  const location = useLocation();
  const { fetchAll } = useAcademicQueriesHigher();
  const [filter, setFilter] = useState({});
  const schoolId = useSchoolId();

  const { isLoading, isError, error, data, refetch } = useQuery<{
    data: IAcademicListItemHigher[];
  }>(
    `academicsHigherList${schoolId}?${stringify(filter)}`,
    () => {
      return fetchAll({
        schoolId,
        ...filter,
      });
    },
    {
      enabled: !disableAutoFetch,
    },
  );

  const applyFilter = useCallback(
    (filter) => {
      setFilter({
        majorId: filter.major?.id,
        degreeId: filter.degree?.id,
        programType: filter.programType?.id,
        intake: filter.intake?.id,
      });

      history.replace({
        pathname: location.pathname,
        search: "?filters=" + JSON.stringify(replaceForURLOptions(filter)),
      });
    },
    [setFilter],
  );

  let errorMessage;
  if (isError) {
    const { message } = mutateErrors(error);
    errorMessage = message;
  }

  return {
    isLoading,
    isError,
    errorMessage,
    applyFilter,
    academicWizardConfigs,
    programWizardConfigs,
    intakeWizardConfigs,
    refetchAcademics: refetch,
    academics: data?.data || [],
  };
};
